import { keysToCamelCase } from "zod-to-camel-case";

import type {
  Features,
  FeaturesCamel,
} from "@/schema/public/components/features/features.schema";

export const featuresFixture = ({
  overrides = {},
}: {
  overrides?: Partial<Features>;
} = {}): Features => ({
  pe_practical: true,
  ...overrides,
});

export const featuresFixtureCamel = ({
  overrides = {},
}: {
  overrides?: Partial<FeaturesCamel>;
} = {}): FeaturesCamel => ({
  ...keysToCamelCase(featuresFixture()),
  ...overrides,
});

export default featuresFixture;
